import { LoadingOutlined } from '@ant-design/icons'
import { Button, Col, Form, Input, Row, Space, Spin, Table, TableColumnsType } from 'antd'
import clsx from 'clsx'
import {
  DATE_FORMAT_DISPLAY,
  DEFAULT_PAGE,
  SubcriptionsStatus,
  SubscriptionsInitial,
  SubscriptionsStatus,
  SubscriptionsStatusLabel,
  SubscriptionsType
} from 'configs/constant'
import dayjs from 'dayjs'
import { responseGetSubscriptions } from 'models/appSetting'
import { IsSubscribeType, OS_TYPE, ResponseMagazineType } from 'models/magazine'
import EmptyCommon from 'pages/common/EmptyCommon/EmptyCommon'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { apiGetProductsAtStore, getAppSettingApi, getJwtInformApi, saveApppSettingApi, saveJwtInform } from 'services/appSettingService'
import { getMagazineApi } from 'services/magazineService'
import { fetchExpirationCertificateApi, getDeviceNotificationApi, uploadCertificate } from 'services/notification'
import { getSubscriptions, saveSubscriptions } from 'services/subscriptionService'
import { notifyError, notifySuccess } from 'utilities/Notification'
import { getFileNameFormUrl, renderReadTrial } from 'utilities/helpers'
import styles from './AppSetting.module.scss'

const AppSetting = () => {
  const location = useLocation()
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const [isLoading, setIsloading] = useState(true)
  const [numberOfDevice, setNumberOfDevice] = useState({
    ios_amount: 0,
    android_amount: 0
  })
  const [certificateExp, setCertificateExp] = useState('')
  const [shareSecret, setShareScret] = useState('')
  const [bundelId, setBundelId] = useState('')
  const [packageName, setPackageName] = useState('')
  const [formInput, setFormInput] = useState<{
    privacy_file: any
    law_file: any
    term_file: any
    help_file: string
    android_help_file: string
    file_push_cert: any
    firebase: string
    logo: any
    login_url: string
    copyright: string
    appstore_url: string
    googleplay_url: string
  }>({
    law_file: '',
    privacy_file: '',
    term_file: '',
    help_file: '',
    android_help_file: '',
    file_push_cert: null,
    firebase: '',
    logo: '',
    login_url: '',
    copyright: '',
    appstore_url: '',
    googleplay_url: ''
  })
  const [jwtInform, setJwtInform] = useState({
    ios_key_file: '',
    ios_kid: '',
    ios_issue: '',
    android_key_file: ''
  })
  const [subscripttionPush, setSubscriptionPush] = useState<responseGetSubscriptions[]>([])
  const [productsGoogleStore, setProductGoogleStore] = useState<any[]>([])
  const [productsAppleStore, setProductAppleStore] = useState<any[]>([])
  const [pdfTrial, setPdfTrial] = useState<ResponseMagazineType>()

  const getListSubscription = async () => {
    setIsloading(true)
    try {
      let productsGoogleStore: any[] = []
      let productsAppleStore: any[] = []
      const dataGoostore = await apiGetProductsAtStore({
        app_id: location.state?.appId,
        os_type: OS_TYPE.ANDROID
      })
      if (dataGoostore.success) {
        productsGoogleStore = dataGoostore.message.subscriptions.map((product: any) => ({
          productId: product.productId,
          status:!!product.basePlans ? product.basePlans[0].state : 'DRAFT'
        }))
        setProductGoogleStore(productsGoogleStore)
      }
      const dataAppStore = await apiGetProductsAtStore({
        app_id: location.state?.appId,
        os_type: OS_TYPE.IOS
      })
      if (dataAppStore.success) {
        productsAppleStore = dataAppStore.message.included.map((product: any) => ({
          productId: product.attributes.productId,
          status: product.attributes.state
        }))
        setProductAppleStore(productsAppleStore)
      }
      const response = await getSubscriptions({
        app_id: location?.state?.appId
      })

      if (response.success) {
        const listSubscription = response.data
        const convertData = listSubscription.map((subs: any) => {
          if (subs.os_type === OS_TYPE.ANDROID) {
            const findProduct = productsGoogleStore.find((product: any) => product.productId === subs.product_id)
            if (findProduct) {
              return {
                ...subs,
                status: SubscriptionsStatus[findProduct.status]
              }
            } else if (subs.product_id) {
              return {
                ...subs,
                status: SubcriptionsStatus.PENDING
              }
            }
          } else {
            const findProduct = productsAppleStore.find((product: any) => product.productId === subs.product_id)
            if (findProduct) {
              return {
                ...subs,
                status: findProduct.status === 'APPROVED' ? SubcriptionsStatus.SETUP_DONE : SubcriptionsStatus.PENDING
              }
            } else if (subs.product_id) {
              return {
                ...subs,
                status: SubcriptionsStatus.PENDING
              }
            }
          }
          return {
            ...subs,
            status: SubcriptionsStatus.NOT_SETUP
          }
        })
        setSubscriptionPush(convertData)
      } else {
        setSubscriptionPush(SubscriptionsInitial)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('error subscription', error)
    }
    setIsloading(false)
  }

  const getNumberOfDevices = async () => {
    setIsloading(true)
    try {
      const response = await getDeviceNotificationApi({
        app_id: location?.state?.appId
      })
      if (response.success) {
        setNumberOfDevice(response.data)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('error number of device', error)
    }
    setIsloading(false)
  }

  const getCertificate = async () => {
    setIsloading(true)

    const expCertificate = await fetchExpirationCertificateApi({
      app_id: location?.state?.appId
    })
    setCertificateExp(expCertificate.utcTime)
    setIsloading(false)
  }

  const getAppSetting = async () => {
    setIsloading(true)
    const dataSetting = await getAppSettingApi({
      app_id: location?.state?.appId
    })
    setShareScret(dataSetting.shared_secret)
    setBundelId(dataSetting.ios_app_id)
    setPackageName(dataSetting.android_app_id)
    setFormInput({
      ...formInput,
      privacy_file: getFileNameFormUrl(dataSetting.privacy_file_url),
      law_file: getFileNameFormUrl(dataSetting.law_file_url),
      term_file: getFileNameFormUrl(dataSetting.term_file_url),
      logo: getFileNameFormUrl(dataSetting.logo_url),
      help_file: getFileNameFormUrl(dataSetting.help_file_url),
      android_help_file: getFileNameFormUrl(dataSetting.android_help_file_url),
      file_push_cert: dataSetting.certificate.length
        ? {
          name: getFileNameFormUrl(dataSetting.certificate[0].p12_url)
        }
        : null,
      firebase: dataSetting.certificate.length ? getFileNameFormUrl(dataSetting.certificate[0].firebase_url) : '',
      login_url: dataSetting.login_url,
      copyright: dataSetting.copyright,
      appstore_url: dataSetting.appstore_url,
      googleplay_url: dataSetting.googleplay_url
    })
    setIsloading(false)
  }

  const getListMagazine = async () => {
    try {
      const Magazines = await getMagazineApi({
        page: DEFAULT_PAGE,
        per_page: 1,
        app_id: location?.state?.appId,
        is_subscribable: IsSubscribeType.SUBSCRIBE
      })
      if (Magazines.list.length) {
        setPdfTrial(Magazines.list[0])
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('error Magazines', error)
    }
  }

  const hangleChangeSubscription = (type: number, osType: number, key: string, value: string) => {
    const newSubscription = subscripttionPush.map((item) => {
      if (item.type === type && item.os_type === osType) {
        return {
          ...item,
          [key]: value
        }
      }
      return item
    })
    setSubscriptionPush(newSubscription)
  }

  const handleSaveListSubcription = async () => {
    setIsloading(true)
    const data = {
      subscriptions: subscripttionPush.map((item: responseGetSubscriptions) => {
        if (item.os_type === OS_TYPE.ANDROID) {
          const findProduct = productsGoogleStore.find((product: any) => product.productId === item.product_id)
          if (!findProduct) {
            return {
              ...item,
              status: SubcriptionsStatus.NOT_SETUP,
              product_id: item?.product_id?.trim()
            }
          }
        } else if (item.os_type === OS_TYPE.IOS) {
          const findProduct = productsAppleStore.find((product: any) => product.productId === item.product_id)
          if (!findProduct) {
            return {
              ...item,
              status: SubcriptionsStatus.NOT_SETUP,
              product_id: item?.product_id?.trim()
            }
          }
        }
        return {
          status: item.status,
          os_type: item.os_type,
          type: item.type,
          name: item.name,
          product_id: item?.product_id?.trim()
        }
      })
    }
    const response = await saveSubscriptions(location?.state?.appId, data)
    if (response.success) {
      notifySuccess({
        message: t('common.create_success')
      })
      getListSubscription()
    } else {
      notifyError({
        message: t('common.create_fail')
      })
    }
    setIsloading(false)
  }

  const handleChangeFile = async (e: any, key: string, fileType?: string) => {
    const file = e.target.files[0]
    if (!!fileType && !file?.name.includes(fileType)) {
      notifyError({
        message: t('common.create_fail')
      })
      return
    }
    if (key === 'file_push_cert') {
      const formData = new FormData()
      formData.append('app_id', location.state?.appId)
      formData.append('certificate', file)
      const response = await uploadCertificate(formData)
      if (response.success) {
        setFormInput({
          ...formInput,
          file_push_cert: {
            ...formInput.file_push_cert,
            name: getFileNameFormUrl(response.data.p12_url)
          }
        })
        notifySuccess({
          message: t('common.create_success')
        })
      } else {
        notifyError({
          message: response.data.error?.error_message
        })
      }
    } else if (key === 'firebase') {
      const formData = new FormData()
      formData.append('app_id', location.state?.appId)
      formData.append('firebase', file)
      const response = await uploadCertificate(formData)
      if (response.success) {
        setFormInput({
          ...formInput,
          firebase: getFileNameFormUrl(response.data.firebase_url)
        })
        notifySuccess({
          message: t('common.create_success')
        })
      }
    } else {
      const formData = new FormData()
      formData.append('app_id', location.state?.appId)
      formData.append(key, file)
      formData.append('_method', 'PUT')
      const response = await saveApppSettingApi(formData)
      if (response.success) {
        setFormInput({
          ...formInput,
          [key]: getFileNameFormUrl(response.data[`${key}_url`])
        })
        notifySuccess({
          message: t('common.create_success')
        })
      } else {
        notifyError({
          message: t('common.create_fail')
        })
      }
    }
    e.target.value = null
  }

  const handleChangeInput = (e: any, key: string) => {
    setFormInput({
      ...formInput,
      [key]: e.target.value
    })
  }

  const handleSaveInputField = async (key: string) => {
    const formData = new FormData()
    formData.append('app_id', location.state?.appId)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    formData.append(key, formInput[key] || '')
    formData.append('_method', 'PUT')
    const response = await saveApppSettingApi(formData)
    if (response.success) {
      setFormInput({
        ...formInput,
        [key]: response.data[`${key}`]
      })
      notifySuccess({
        message: t('common.create_success')
      })
    }
  }

  // using for status product
  const getJwtInform = async () => {
    setIsloading(true)
    const dataJwt = await getJwtInformApi({
      app_id: location?.state?.appId
    })
    setJwtInform({
      ios_key_file: getFileNameFormUrl(dataJwt?.ios_key_file_url),
      android_key_file: getFileNameFormUrl(dataJwt?.android_key_file_url),
      ios_issue: dataJwt?.ios_issue,
      ios_kid: dataJwt?.ios_kid
    })
    setIsloading(false)
  }

  const handleSaveFileJwtInform = async (e: any, key: string, fileType?: string) => {
    const file = e.target.files[0]
    if (!!fileType && !file?.name.includes(fileType)) {
      notifyError({
        message: t('common.create_fail')
      })
      return
    }
    const formData = new FormData()
    formData.append('app_id', location.state?.appId)
    formData.append(key, file)
    const response = await saveJwtInform(formData)
    if (response.success) {
      setJwtInform({
        ...jwtInform,
        [key]: getFileNameFormUrl(response.data[`${key}_url`])
      })
      notifySuccess({
        message: t('common.create_success')
      })
    } else {
      notifyError({
        message: t('common.create_fail')
      })
    }
  }

  const handleSaveInputFieldJWTInform = async (key: string) => {
    const formData = new FormData()
    formData.append('app_id', location.state?.appId)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    formData.append(key, jwtInform[key] || '')
    const response = await saveJwtInform(formData)
    if (response.success) {
      setJwtInform({
        ...jwtInform,
        [key]: response.data[`${key}`]
      })
      notifySuccess({
        message: t('common.create_success')
      })
    } else {
      notifyError({
        message: t('common.create_fail')
      })
    }
  }

  // eslint-disable-next-line no-unused-vars
  const getColumns: (type: number) => TableColumnsType<responseGetSubscriptions> = (type: number) => {
    return [
      {
        title: t('subscriptions.period'),
        key: 'type',
        dataIndex: 'type',
        align: 'center',
        width: '20%',
        render: (type, record) => {
          return <p>{SubscriptionsType.find((o) => o.value === record.type)?.label}</p>
        }
      },
      {
        title: type === OS_TYPE.ANDROID ? 'Android' : 'iOS',
        dataIndex: 'os_type',
        key: 'os_type',
        align: 'center',
        render: (osType, record) => {
          return (
            <div className={styles.columnDevice}>
              <p className={styles.columnDevice_title}>
                {t('subscriptions.status')} : {SubscriptionsStatusLabel[record.status]}
                {/* {record.status} */}
              </p>
              <div className={styles.childrenRow}>
                <span>Product ID:</span>
                <Input
                  value={record.product_id}
                  onChange={(e) => hangleChangeSubscription(record.type, record.os_type, 'product_id', e.target.value)}
                />
              </div>
              <div className={styles.childrenRow}>
                <span>{t('subscriptions.button_name')}:</span>
                <Input value={record.name} onChange={(e) => hangleChangeSubscription(record.type, record.os_type, 'name', e.target.value)} />
              </div>
            </div>
          )
        }
      }
    ]
  }

  useEffect(() => {
    getListSubscription()
    getNumberOfDevices()
    getAppSetting()
    getCertificate()
    getJwtInform()
    getListMagazine()
  }, [])

  return (
    <section className={styles.main}>
      <p>{t('subscriptions.setting')}</p>

      <Row gutter={16}>
        <Col span={12}>
          <p className={styles.title}>
            iOSバンドルID: <span> {bundelId || t('app.not_have')}</span>
          </p>

          <p className={styles.title}>
            Androidパッケージ名: <span> {packageName || t('app.not_have')}</span>
          </p>
        </Col>
      </Row>

      <Row gutter={16}>
        {shareSecret && (
          <Col span={12}>
            <p className={styles.title}>
              SHARED_SECRET (iOS): <span> {shareSecret}</span>
            </p>
          </Col>
        )}
      </Row>

      <Button type="default" className="btn" onClick={handleSaveListSubcription}>
        {t('subscriptions.applicable')}
      </Button>
      {isLoading ? (
        <div className={styles.loading}>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
        </div>
      ) : (
        <>
          <div className={styles.tableContainer}>
            <Table
              dataSource={subscripttionPush.filter((o) => o.os_type === OS_TYPE.IOS)}
              bordered
              columns={getColumns(OS_TYPE.IOS)}
              className={styles.table}
              locale={{
                emptyText: <EmptyCommon />
              }}
              pagination={false}
            />
            <Table
              dataSource={subscripttionPush.filter((o) => o.os_type === OS_TYPE.ANDROID).sort((a, b) => a.type - b.type)}
              bordered
              columns={getColumns(OS_TYPE.ANDROID)}
              className={styles.table}
              locale={{
                emptyText: <EmptyCommon />
              }}
              pagination={false}
            />
          </div>
          <Form form={form} className={styles.section2}>
            <Row gutter={16} style={{ marginBottom: '2rem' }}>
              <Col span={7}>
                <p className={styles.title}>{t('app.trial_url')}:</p>
              </Col>
              <Col span={16}>
                {!!pdfTrial && (
                  <span
                    className={styles.trial_url}
                    onClick={() =>
                      window.open(renderReadTrial(process.env.REACT_APP_DOMAIN_WEB || '', location?.state?.latinName, pdfTrial?.id || 0))
                    }
                  >
                    {renderReadTrial(process.env.REACT_APP_DOMAIN_WEB || '', location?.state?.latinName, pdfTrial?.id || 0)}
                  </span>
                )}
              </Col>
            </Row>

            <Form.Item
              name="privacy_file"
              rules={[
                {
                  validator: () => (!!formInput.privacy_file ? Promise.resolve() : Promise.reject()),
                  message: ''
                }
              ]}
            >
              <Row gutter={16}>
                <Col span={7}>
                  <span>{t('privacy')}:</span>
                </Col>
                <Col span={16}>
                  <Space>
                    <label htmlFor="input_privacy_file" className={clsx(styles.btn, 'btn')}>
                      {t('button.select_and_register')}
                    </label>
                    {!!formInput.privacy_file && <span className={styles.file_input}>{formInput.privacy_file}</span>}
                  </Space>
                  <input
                    type="file"
                    id="input_privacy_file"
                    name="TXT"
                    accept=".txt"
                    onChange={(e) => {
                      handleChangeFile(e, 'privacy_file', 'txt')
                    }}
                    style={{
                      display: 'none'
                    }}
                  />
                </Col>
              </Row>
            </Form.Item>

            <Form.Item
              name="term_file"
              rules={[
                {
                  validator: () => (!!formInput.term_file ? Promise.resolve() : Promise.reject()),
                  message: ''
                }
              ]}
            >
              <Row gutter={16}>
                <Col span={7}>
                  <span>{t('term')}:</span>
                </Col>
                <Col span={16}>
                  <Space>
                    <label htmlFor="input_term_file" className={clsx(styles.btn, 'btn')}>
                      {t('button.select_and_register')}
                    </label>
                    {!!formInput.term_file && <span className={styles.file_input}>{formInput.term_file}</span>}

                    <input
                      type="file"
                      id="input_term_file"
                      name="TXT"
                      accept=".txt"
                      onChange={(e) => {
                        handleChangeFile(e, 'term_file', 'txt')
                      }}
                      style={{
                        display: 'none'
                      }}
                    />
                  </Space>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item
              name="law_file"
              rules={[
                {
                  validator: () => (!!formInput.law_file ? Promise.resolve() : Promise.reject()),
                  message: ''
                }
              ]}
            >
              <Row gutter={16}>
                <Col span={7}>
                  <span>{t('app.law_file')}:</span>
                </Col>
                <Col span={16}>
                  <Space>
                    <label htmlFor="input_law_file" className={clsx(styles.btn, 'btn')}>
                      {t('button.select_and_register')}
                    </label>
                    {!!formInput.law_file && <span className={styles.file_input}>{formInput.law_file}</span>}

                    <input
                      type="file"
                      id="input_law_file"
                      name="TXT"
                      accept=".txt"
                      onChange={(e) => {
                        handleChangeFile(e, 'law_file', 'txt')
                      }}
                      style={{
                        display: 'none'
                      }}
                    />
                  </Space>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item
              name="help_file_ios"
              rules={[
                {
                  validator: () => (!!formInput.law_file ? Promise.resolve() : Promise.reject()),
                  message: ''
                }
              ]}
            >
              <Row gutter={16}>
                <Col span={7}>
                  <span>{t('app.upload_file_help')}iOS:</span>
                </Col>
                <Col span={16}>
                  <Space>
                    <label htmlFor="input_help_file" className={clsx(styles.btn, 'btn')}>
                      {t('button.select_and_register')}
                    </label>
                    {!!formInput.help_file && <span className={styles.file_input}>{formInput.help_file}</span>}

                    <input
                      type="file"
                      id="input_help_file"
                      name="input_help_file"
                      accept=".txt"
                      onChange={(e) => {
                        handleChangeFile(e, 'help_file', 'txt')
                      }}
                      style={{
                        display: 'none'
                      }}
                    />
                  </Space>
                </Col>
              </Row>
            </Form.Item>
            <Form.Item
              name="android_help_file"
              rules={[
                {
                  validator: () => (!!formInput.law_file ? Promise.resolve() : Promise.reject()),
                  message: ''
                }
              ]}
            >
              <Row gutter={16}>
                <Col span={7}>
                  <span>{t('app.upload_file_help')}Android:</span>
                </Col>
                <Col span={16}>
                  <Space>
                    <label htmlFor="input_help_file_android" className={clsx(styles.btn, 'btn')}>
                      {t('button.select_and_register')}
                    </label>
                    {!!formInput.android_help_file && <span className={styles.file_input}>{formInput.android_help_file}</span>}

                    <input
                      type="file"
                      id="input_help_file_android"
                      name="input_help_file_android"
                      accept=".txt"
                      onChange={(e) => {
                        handleChangeFile(e, 'android_help_file', 'txt')
                      }}
                      style={{
                        display: 'none'
                      }}
                    />
                  </Space>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item
              name="file_push_cert"
              rules={[
                {
                  validator: () => (!!formInput.file_push_cert ? Promise.resolve() : Promise.reject()),
                  message: ''
                }
              ]}
            >
              <Row gutter={16}>
                <Col span={7}>
                  <div className={styles.title}>
                    <span>{t('certificate.exp_date_title')}</span>
                    <span className={styles.info}>{certificateExp && dayjs(certificateExp).format(DATE_FORMAT_DISPLAY)}</span>
                    {dayjs(certificateExp).isBefore(dayjs()) && <span className={styles.warning}>{t('certificate.warning')}</span>}
                  </div>
                </Col>
                <Col span={16}>
                  <Space>
                    <label htmlFor="input_file_push_cert" className={clsx(styles.btn, 'btn')}>
                      {t('button.select_and_register')}
                    </label>
                    {!!formInput.file_push_cert && <span className={styles.file_input}>{formInput.file_push_cert.name}</span>}
                    <input
                      type="file"
                      id="input_file_push_cert"
                      name="P12"
                      accept=".p12"
                      onChange={(e) => {
                        handleChangeFile(e, 'file_push_cert', 'p12')
                      }}
                      style={{
                        display: 'none'
                      }}
                    />
                  </Space>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item name="firebase">
              <Row gutter={16}>
                <Col span={7}>
                  <span>{t('app.firebase_credentials')}:</span>
                </Col>
                <Col span={16}>
                  <Space>
                    <label htmlFor="input_firebase" className={clsx(styles.btn, 'btn')}>
                      {t('button.select_and_register')}
                    </label>
                    {!!formInput.firebase && <span className={styles.file_input}>{formInput.firebase}</span>}

                    <input
                      type="file"
                      id="input_firebase"
                      name="input_firebase"
                      accept=".json"
                      onChange={(e) => {
                        handleChangeFile(e, 'firebase', 'json')
                      }}
                      style={{
                        display: 'none'
                      }}
                    />
                  </Space>
                </Col>
              </Row>
            </Form.Item>

            <Row gutter={16}>
              <Col span={7}>
                <p className={styles.title}>{t('certificate.device_push')}</p>
              </Col>
              <Col span={16}>
                <Space>
                  <p className={styles.title}>
                    <span>iOS {numberOfDevice?.ios_amount}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>Android {numberOfDevice?.android_amount}</span>
                  </p>
                </Space>
              </Col>
            </Row>

            <Form.Item
              name="logo"
              rules={[
                {
                  validator: () => (!!formInput.logo ? Promise.resolve() : Promise.reject()),
                  message: ''
                }
              ]}
            >
              <Row gutter={16}>
                <Col span={7}>
                  <span>{t('app.logo_setting')}:</span>
                </Col>
                <Col span={16}>
                  <Space>
                    <label htmlFor="input_logo" className={clsx(styles.btn, 'btn')}>
                      {t('button.select_and_register')}
                    </label>
                    {!!formInput.logo && <span className={styles.file_input}>{formInput.logo}</span>}

                    <input
                      type="file"
                      id="input_logo"
                      name="TXT"
                      accept=".jpg, jpeg, .png"
                      onChange={(e) => {
                        handleChangeFile(e, 'logo')
                      }}
                      style={{
                        display: 'none'
                      }}
                    />
                  </Space>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item>
              <Row gutter={16}>
                <Col span={7}>
                  <label>{t('app.login_url_setting')}:</label>
                </Col>
                <Col span={16}>
                  <Space>
                    <Input
                      value={formInput.login_url}
                      onChange={(e) => {
                        handleChangeInput(e, 'login_url')
                      }}
                      style={{ width: '70rem' }}
                    ></Input>
                    <Button
                      className="btn"
                      type="default"
                      onClick={() => {
                        handleSaveInputField('login_url')
                      }}
                    >
                      {t('button.apply')}
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item>
              <Row gutter={16}>
                <Col span={7}>
                  <label>{t('app.copyright_setting')}:</label>
                </Col>
                <Col span={16}>
                  <Space>
                    <Input
                      value={formInput.copyright}
                      onChange={(e) => {
                        handleChangeInput(e, 'copyright')
                      }}
                      style={{ width: '70rem' }}
                    ></Input>
                    <Button
                      className="btn"
                      type="default"
                      onClick={() => {
                        handleSaveInputField('copyright')
                      }}
                    >
                      {t('button.apply')}
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item>
              <Row gutter={16}>
                <Col span={7}>
                  <label>App Store URL:</label>
                </Col>
                <Col span={16}>
                  <Space>
                    <Input
                      value={formInput.appstore_url}
                      onChange={(e) => {
                        handleChangeInput(e, 'appstore_url')
                      }}
                      style={{ width: '70rem' }}
                    ></Input>
                    <Button
                      className="btn"
                      type="default"
                      onClick={() => {
                        handleSaveInputField('appstore_url')
                      }}
                    >
                      {t('button.apply')}
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item>
              <Row gutter={16}>
                <Col span={7}>
                  <label>Google Play URL:</label>
                </Col>
                <Col span={16}>
                  <Space>
                    <Space>
                      <Input
                        value={formInput.googleplay_url}
                        onChange={(e) => {
                          handleChangeInput(e, 'googleplay_url')
                        }}
                        style={{ width: '70rem' }}
                      ></Input>
                      <Button
                        className="btn"
                        type="default"
                        onClick={() => {
                          handleSaveInputField('googleplay_url')
                        }}
                      >
                        {t('button.apply')}
                      </Button>
                    </Space>
                  </Space>
                </Col>
              </Row>
            </Form.Item>
            {/* key status */}
            <Form.Item name="ios_p8">
              <Row gutter={16}>
                <Col span={7}>
                  <span>API Key (iOS版のProductID状態を取得するためのキーファイル):</span>
                </Col>
                <Col span={16}>
                  <Space>
                    <label htmlFor="ios_p8_file" className={clsx(styles.btn, 'btn')}>
                      {t('button.select_and_register')}
                    </label>
                    {!!jwtInform.ios_key_file && <span className={styles.file_input}>{jwtInform.ios_key_file.replace('.txt', '.p8')}</span>}

                    <input
                      type="file"
                      id="ios_p8_file"
                      name="ios_p8_file"
                      accept=".p8"
                      onChange={(e) => {
                        handleSaveFileJwtInform(e, 'ios_key_file', '.p8')
                      }}
                      style={{
                        display: 'none'
                      }}
                    />
                  </Space>
                </Col>
              </Row>
            </Form.Item>
            <Form.Item>
              <Row gutter={16}>
                <Col span={7}>
                  <label>KEY ID (iOS版のProductID状態を取得するためのキーID):</label>
                </Col>
                <Col span={16}>
                  <Space>
                    <Input
                      value={jwtInform.ios_kid}
                      onChange={(e) => {
                        setJwtInform({
                          ...jwtInform,
                          ios_kid: e.target.value
                        })
                      }}
                      style={{ width: '70rem' }}
                    ></Input>
                    <Button
                      className="btn"
                      type="default"
                      onClick={() => {
                        handleSaveInputFieldJWTInform('ios_kid')
                      }}
                    >
                      {t('button.apply')}
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Form.Item>
            <Form.Item>
              <Row gutter={16}>
                <Col span={7}>
                  <label>IssuerID (iOS版のProductID状態を取得するためのIssuerID):</label>
                </Col>
                <Col span={16}>
                  <Space>
                    <Input
                      value={jwtInform.ios_issue}
                      onChange={(e) => {
                        setJwtInform({
                          ...jwtInform,
                          ios_issue: e.target.value
                        })
                      }}
                      style={{ width: '70rem' }}
                    ></Input>
                    <Button
                      className="btn"
                      type="default"
                      onClick={() => {
                        handleSaveInputFieldJWTInform('ios_issue')
                      }}
                    >
                      {t('button.apply')}
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Form.Item>
            <Form.Item name="android_json">
              <Row gutter={16}>
                <Col span={7}>
                  <span>GooglePlay_Credentials (Android版のProductID状態を取得するためのキーファイル):</span>
                </Col>
                <Col span={16}>
                  <Space>
                    <label htmlFor="android_json_file" className={clsx(styles.btn, 'btn')}>
                      {t('button.select_and_register')}
                    </label>
                    {!!jwtInform.android_key_file && <span className={styles.file_input}>{jwtInform.android_key_file}</span>}

                    <input
                      type="file"
                      id="android_json_file"
                      name="android_json_file"
                      accept=".json"
                      onChange={(e) => {
                        handleSaveFileJwtInform(e, 'android_key_file', '.json')
                      }}
                      style={{
                        display: 'none'
                      }}
                    />
                  </Space>
                </Col>
              </Row>
            </Form.Item>
          </Form>
        </>
      )}
    </section>
  )
}

export default AppSetting
